import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/events/global-freight-summit-2023/GlobalFreightSummit2023.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/GlobalFreightSummit2023/components/SectionHeader'));
const SectionDescription = dynamic(() => import('sections/Events/GlobalFreightSummit2023/components/SectionDescription'));
const SectionVideo = dynamic(() => import('sections/Events/GlobalFreightSummit2023/components/SectionVideo'));
const SectionFeatures = dynamic(() => import('sections/Events/GlobalFreightSummit2023/components/SectionFeatures'));
const SectionSponsor = dynamic(() => import('sections/Events/GlobalFreightSummit2023/components/SectionSponsor'));

export default function GlobalFreightSummitPage() {
  return (
    <div className={cn('global-freight-summit-2023')}>
      <SectionHeader/>
      <SectionDescription/>
      <SectionVideo/>
      <SectionFeatures/>
      <SectionSponsor/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'World Freight Summit | Global Freight Summit Event by DFA',
      description:
        'Enroll now & stay informed about the Global Freight Summit 2024. Unlock unique features within our membership plan & explore the future of freight logistics.',
      path: '/events/global-freight-summit',
    },
  };
};

GlobalFreightSummitPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
